import React from 'react';

// Placar: topo azul-marinho opcional e uma faixa branca de números.
// items: [{ icon, value, label, hint, tone: navy | lime | danger }]
// inline: ícone à esquerda do número (Flashcards, Erros, Conquistas).
export function ScoreCard({ top, stripe = false, items = [], inline = false, className = '', tour }) {
  return (
    <div className={`ss-score ${inline ? 'ss-score--inline' : ''} ${className}`} data-tour={tour}>
      {top && (
        <div className={`ss-score__top ${stripe ? 'ss-score__top--stripe' : ''}`}>
          {top}
        </div>
      )}
      {items.length > 0 && (
        <div className="ss-score__cells" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
          {items.map(({ icon: Icon, value, label, hint, tone = 'navy', onClick }, i) => {
            const Tag = onClick ? 'button' : 'div';
            return (
              <Tag
                key={i}
                type={onClick ? 'button' : undefined}
                onClick={onClick}
                className={`ss-score__cell ss-score__cell--${tone} ${onClick ? 'ss-score__cell--interactive' : ''}`}
              >
                {Icon && (
                  <span className="ss-score__icon">
                    <Icon size={inline ? 17 : 15} strokeWidth={2.2} aria-hidden="true" />
                  </span>
                )}
                <span className="ss-score__text">
                  <span className="ss-score__value">{value}</span>
                  <span className="ss-score__label">
                    {label}
                    {hint && <span className="ss-score__hint"> {hint}</span>}
                  </span>
                </span>
              </Tag>
            );
          })}
        </div>
      )}
    </div>
  );
}

// Eyebrow, número grande e barra do topo azul-marinho do placar.
export function ScoreHero({ eyebrow, value, caption, percent, marker, markerLabel, aside }) {
  return (
    <div className="ss-scorehero">
      <div className="ss-scorehero__row">
        <div className="ss-scorehero__text">
          {eyebrow && <span className="ss-scorehero__eyebrow">{eyebrow}</span>}
          {caption && <span className="ss-scorehero__caption">{caption}</span>}
        </div>
        {value != null && <span className="ss-scorehero__value">{value}</span>}
        {aside}
      </div>
      {percent != null && (
        <div className="ss-scorehero__bar">
          <span className="ss-scorehero__fill" style={{ width: `${Math.min(100, Math.max(0, percent))}%` }} />
          {marker != null && (
            <span className="ss-scorehero__marker" style={{ left: `${marker}%` }}>
              {markerLabel && <span>{markerLabel}</span>}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

// Segmentado em pílula. options: [{ value, label, icon, count }]
export function Segmented({ options, value, onChange, ariaLabel, className = '' }) {
  return (
    <div className={`ss-seg ${className}`} role="tablist" aria-label={ariaLabel}>
      {options.map(({ value: v, label, icon: Icon, count }) => (
        <button
          key={v}
          type="button"
          role="tab"
          aria-selected={value === v}
          className={`ss-seg__item ${value === v ? 'is-active' : ''}`}
          onClick={() => onChange(v)}
        >
          {Icon && <Icon size={14} strokeWidth={2.2} aria-hidden="true" />}
          {label && <span>{label}</span>}
          {count != null && <span className="ss-seg__count">{count}</span>}
        </button>
      ))}
    </div>
  );
}
